import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import applicationsService from "@/services/applicationsService";

import AppCard from "@/components/applications/appCard";

const Applications = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [applications, setApplications] = useState([]);
  const [installed, setInstalled] = useState([]);

  useEffect(() => {
    applicationsService.getApplications().then((res) => {
      setApplications(res);
      setLoading(false);
    });

    // check installed
    applicationsService.checkInstalled().then((res) => setInstalled(res.data));
  }, []);

  const infoBip = {
    name: "Infobip",
    slug: "infobip",
    subtitle: t("applications.infobip.subtitle", {
      defaultValue:
        "Infobip ile elektronik garanti belgesine geçin; baskı, arşivleme ve kargo masraflarından kurtulun; garanti belgelerini anında müşterileriniz ile paylaşın.",
    }),
    logoUrl:
      "https://cdn-web.infobip.com/uploads/2023/08/Infobip-place-holder-1.png",
    header: t("applications.infobip.subtitle", {
      defaultValue:
        "Infobip ile elektronik garanti belgesine geçin; baskı, arşivleme ve kargo masraflarından kurtulun; garanti belgelerini anında müşterileriniz ile paylaşın.",
    }),
    description: t("applications.infobip.subtitle", {
      defaultValue:
        "Infobip ile elektronik garanti belgesine geçin; baskı, arşivleme ve kargo masraflarından kurtulun; garanti belgelerini anında müşterileriniz ile paylaşın.",
    }),
  };

  const verimor = {
    name: "Verimor",
    slug: "verimor",
    subtitle: t("applications.verimor.subtitle", {
      defaultValue:
        "Verimor SMS entegrasyonu ile elektronik garanti belgesine geçin; garanti belgelerini anında müşterileriniz ile SMS ile paylaşın.",
    }),
    logoUrl:
      "https://cdn.egaranti.com/tr/merchant-integrations/logo/verimor.png",
    header: t("applications.verimor.subtitle", {
      defaultValue:
        "Verimor SMS entegrasyonu ile elektronik garanti belgesine geçin; garanti belgelerini anında müşterileriniz ile SMS ile paylaşın.",
    }),
    description: t("applications.verimor.description", {
      defaultValue:
        "Verimor SMS entegrasyonu ile elektronik garanti belgesine geçin; garanti belgelerini anında müşterileriniz ile SMS ile paylaşın. Kullanıcı adı, şifre ve kaynak adresi bilgilerinizle hızlıca entegre olun.",
    }),
  };

  const jetsms = {
    name: "JetSMS",
    slug: "jetsms",
    subtitle: t("applications.jetsms.subtitle", {
      defaultValue:
        "JetSMS SMS entegrasyonu ile elektronik garanti belgesine geçin; garanti belgelerini anında müşterileriniz ile SMS ile paylaşın.",
    }),
    logoUrl:
      "https://cdn.egaranti.com/tr/merchant-integrations/logo/jetsms.png",
    header: t("applications.jetsms.subtitle", {
      defaultValue:
        "JetSMS SMS entegrasyonu ile elektronik garanti belgesine geçin; garanti belgelerini anında müşterileriniz ile SMS ile paylaşın.",
    }),
    description: t("applications.jetsms.description", {
      defaultValue:
        "JetSMS SMS entegrasyonu ile elektronik garanti belgesine geçin; garanti belgelerini anında müşterileriniz ile SMS ile paylaşın. Kullanıcı adı, şifre ve mesaj başlığı (originator) bilgilerinizle hızlıca entegre olun.",
    }),
  };

  return (
    <main className="min-h-full bg-[#F9FAFC] p-7">
      {!loading && (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {applications.map((application) => (
            <AppCard
              installed={installed}
              key={application.id}
              application={application}
            />
          ))}
          <AppCard installed={installed} application={infoBip} />
          <AppCard installed={installed} application={verimor} />
          <AppCard installed={installed} application={jetsms} />
        </div>
      )}
    </main>
  );
};

export default Applications;
